import React from "react";
import { Btn, P } from "../../../../../../AbstractElements";
import { SideHeaderProp } from "../../../../../../Types/Chat.type";

export default function SideHeader({ title, toggle }: SideHeaderProp) {
  return (
    <div className="common-space">
      <P>{title}</P>
      <div className="header-top">
        <Btn color="primary" onClick={toggle} className=" f-w-500">
          <i className="fa fa-plus text-white"></i>
        </Btn>
      </div>
    </div>
  );
}
